import { useTranslation } from 'react-i18next';
import { Select, MenuItem, FormControl } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function SelectController({ options, name, value, label, placeholder, onChange, ...props }) {
  const { t } = useTranslation();

  const handleOnChange = ({ target }) => {
    onChange({ name: target.name, value: target.value });
  };

  const options_ = Array.isArray(options) ? options : [];

  return (
    <FormControl variant="outlined" {...props}>
      <Select IconComponent={KeyboardArrowDownIcon} displayEmpty name={name} value={value} {...props} onChange={handleOnChange}>
        {options_.map(({ label, value }) => (
          <MenuItem key={label} value={value}>
            {t(label)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
